// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Please don't edit this file, unless you want  to change the stage of the application (IOstage and IAstage).
// The Environment variables are set in @app/services/environment.service.ts, every change should be done there.
// Thank you!
export const environment = {
  production: true,
  apiUrl: '',
  currentUrl: '',
  ioApplicationUrl: '',
  IOstage: 'prod', // This can be prod, dev or test
  IAstage: 'prod', // This can be prod, dev or test
  standalone: true
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
